<template>
  <modal
    :show.sync="modals.modal1"
    footerClasses="text-right"
    :largeModal="true"
  >
    <h6
      slot="header"
      class="modal-title text-success font-weight-bold"
      id="modal-title-default"
    >
      Database Sistem Informasi Pajak Daerah
    </h6>
    <div class="d-block" style="overflow-x: auto; white-space: nowrap">
      <div class="row">
        <div class="col-lg-12 col-sm-12">
          <form ref="form">
            <p class="description">
              * Silahkan masukan nomor NPWPD atau nama wajib pajak / pemilik
              yang ingin dicari.
            </p>
            <div class="mb-5">
              <div class="row">
                <div class="col-lg-4 col-sm-6">
                  <base-input
                    placeholder="Nomor NPWPD"
                    v-model="form.npwpd"
                    :valid="true"
                  ></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-sm-3">
                  <base-input
                    placeholder="Nama WP / Pemilik Usaha"
                    v-model="form.keyword"
                    :valid="true"
                  ></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-sm-6">
                  <base-button
                    type="success"
                    icon="ni ni-zoom-split-in"
                    @click="search"
                    >Cari Data</base-button
                  >
                  <base-button type="warning" icon="ni ni-clear" @click="reset"
                    >Reset Data</base-button
                  >
                </div>
              </div>
            </div>
          </form>
          <hr />
          <b-table
            striped
            bordered
            hover
            responsive
            id="my-table"
            ref="table"
            :busy.sync="isBusy"
            :items="myProvider"
            :per-page="perPage"
            :current-page="currentPage"
          ></b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { BTable, BPagination } from "bootstrap-vue";
import axios from "axios";
export default {
  components: {
    Modal,
    PulseLoader,
    BTable,
    BPagination,
  },
  data() {
    return {
      modals: {
        modal1: false,
      },
      htmls: null,
      isBusy: false,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      form: {
        npwpd: null,
        keyword: null,
      },
    };
  },
  methods: {
    showModal() {
      this.modals.modal1 = true;
    },
    hideModal() {
      this.modals.modal1 = false;
    },
    search() {
      this.$refs.table.refresh();
    },
    reset() {
      this.form.npwpd = null;
      this.form.keyword = null;
      this.$refs.table.refresh();
    },
    async myProvider(ctx) {
      this.isBusy = true;
      try {
        const response = await axios.get(
          `/api/v1/database?page=${ctx.currentPage}&npwpd=${this.form.npwpd}&keyword=${this.form.keyword}`
        );
        this.isBusy = false;
        this.rows = response.data.meta.total_count;
        return response.data.items;
      } catch (error) {
        this.isBusy = false;
        return [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 1000px;
  margin: 1.75rem auto;
}
</style>